
import request from '../utils/request';

export async function getWechatConfig(data) {
  return request.post('/vendor/sign', data);
}

